import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FilterBase } from './filter-base';

@Component({
    selector: 'nova-text-filter',
    template: ` <mat-form-field>
        <input
            matInput
            type="text"
            #filterText
            [placeholder]="title"
            [value]="getCurrentValue()"
            (blur)="setFilter(filterText.value)"
            (change)="setFilter(filterText.value)"
            [ngClass]="uniqueFilterClass" />
    </mat-form-field>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, NgClass]
})
export class TextFilterComponent extends FilterBase {
    @Input() title: string;
    @Input() public uniqueFilterClass: string;

    setFilter(value: string) {
        if (value && value.length) {
            this.filterService.filter({
                filters: [
                    {
                        field: this.field,
                        operator: 'startswith',
                        value: value
                    }
                ],
                logic: 'and'
            });
        }
    }
}
